<template>
  <a-select v-model:value="val" :options="options" style="width: 100px;" @select="() => emit('update:value', val)" />
</template>
<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  value: number
}>()

const emit = defineEmits(['update:value'])

const options = [{ value: 0, label: '全部' }, { value: 2, label: '扫码点餐' }, { value: 3, label: '收银台' }, { value: 1, label: '外卖' }]
const val = ref(props.value)

</script>